import AvailabilityEenvandaagPage from "./components/AvailabilityPage";

// Sync route definition
export default {
  path: "/beschikbaarheideenvandaag",
  component: AvailabilityEenvandaagPage,
};
